import React, {Component} from 'react';
import './FormRow.css';

/**
 * A row of {@link FormFieldList} that does not necessarily have a label + input field.
 */
class FormRow extends Component {
	render() {
		return (
			<li className="FormRow">
				{this.props.children}
			</li>
		);
	}
}

export default FormRow;


// WEBPACK FOOTER //
// ./src/widgets/FormRow.js